import React from 'react';
import ReactLoading from 'react-loading';
 
const ScreenLoader = ({ type = 'spin', color = '#989898' }) => (
    <div className='w-screen h-screen grid bg-gray-50 place-content-center'>
        <ReactLoading type={type} color={color} height={47} width={45} />
    </div>
);
 
export default ScreenLoader;